module.exports = __webpack_public_path__ + "static/media/rumi-product-img.13fd1fc7.png";